import { createContext } from 'react';

export const MyContext = createContext("");

export const AdminDashboardContext = createContext("");